import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import theme from './modules/theme'
import entry_video from './modules/entry_video';
import main_videos from "@/store/modules/main_videos";
import ending_video from "@/store/modules/ending_video";
import edit from './modules/edit'
import timer from "@/store/modules/timer";
import music from './modules/music'
import survey_price from "@/store/modules/survey_price";
import price from './modules/price'
import settings from './modules/settings'
import date from './modules/date.js'
import auth from './modules/auth.js'
import cache_videos from "@/store/modules/cache_videos";
import cache_videos_page_context from "@/store/modules/cache_videos_page_context";

Vue.use(Vuex)

export default new Vuex.Store({
    // модуль, синхронизирующий vuex и localStorage
    plugins: [createPersistedState({
        paths: [
            'theme',
            'entry_video',
            'main_videos',
            'ending_video',
            'edit',
            'timer',
            'music',
            'survey_price',
            'price',
            'settings',
            'date',
            'auth'
        ]
    })],
    modules: {
        theme,
        entry_video,
        main_videos,
        ending_video,
        edit,
        timer,
        music,
        survey_price,
        price,
        settings,
        date,
        auth,
        cache_videos,
        cache_videos_page_context
    }
})